export const TEXT = {
    IMAGES: 'images',
    IMAGE: 'image',
    VIDEOS: 'videos',
    VIDEO: 'video'
}